
import React, { useState, useEffect } from "react";
import { ZyppLiteApi } from "../../../API/Zypp-Lite-Api/LiteApi";
import { Snackbar, Alert } from "@mui/material";

export default function WalletDeduction() {
  const [search, setSearch] = useState("");
  const [users, setUsers] = useState<any[]>([]);
  const [expandedRow, setExpandedRow] = useState<number | null>(null);
  const [formValues, setFormValues] = useState<Record<
    number,
    { amount: string; reason: string ; deductionType?: string}
  >>({});
  const [success, setSuccess] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [showErrorSnackbar, setShowErrorSnackbar] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState<"success" | "error">(
      "success"
    );

  useEffect(() => {
    if (!search.trim()) {
      setUsers([]);
      return;
    }

    const delayDebounce = setTimeout(() => {
      handleSearch(search);
    }, 300);

    return () => clearTimeout(delayDebounce);
  }, [search]);

  const handleSearch = async (query: string) => {
    try {
      const res = await ZyppLiteApi.api.getWalletUserDetails(query);
      if (res?.data && Array.isArray(res.data)) {
        setUsers(res.data);
      } else {
        setUsers([]);
      }
    } catch (error) {
      console.error("Error fetching wallet user details:", error);
      setUsers([]);
    }
  };


  const handleInputChange = (
    driverId: number,
    field: "amount" | "reason" | "deductionType",
    value: string
  ) => {
    setFormValues((prev) => ({
      ...prev,
      [driverId]: {
        ...prev[driverId],
        [field]: value,
      },
    }));
  };

  const handleDeduction = async (driverId: number) => {
  const { amount = "", reason = "", deductionType = "" } = formValues[driverId] || {};

  if (!amount || !reason || !deductionType) {
    setSnackbarMessage("Please Enter Amount, Reason and Deduction Type");
    setSnackbarSeverity("error");
    setShowErrorSnackbar(true);
    return;
  }

  try {
    await ZyppLiteApi.api.deductWalletAmount({
      driverId,
      deductionAmount: Number(amount),
      reason,
      deductionType
    });

    setSuccess(true);

    setFormValues((prev) => ({
      ...prev,
      [driverId]: { amount: "", reason: "", deductionType: "" },
    }));

    setExpandedRow(null);
  } catch (error) {
    let message = "Something Failed";
    if (error instanceof Error) {
      //@ts-ignore
      message = error.response.data.message;
    }
    setSnackbarMessage(message);
    setSnackbarSeverity("error");
    setShowErrorSnackbar(true);
  }
};


  return (
    <div className="w-full min-h-screen bg-gray-100 flex flex-col items-center  p-1">
      <h1 className="w-[40%] text-3xl p-4 font-bold">Wallet Deduction</h1>
      <div className="flex w-full max-w-xl mb-8">
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by Vehicle number, Mobile"
          className="flex-1 px-4 py-2 border rounded-lg"
        />
      </div>

      <Snackbar
              open={showErrorSnackbar}
              autoHideDuration={6000}
              onClose={() => setShowErrorSnackbar(false)}
            >
              <Alert severity={snackbarSeverity}>{snackbarMessage}</Alert>
            </Snackbar>

      {users.length > 0 && (
        <div className="bg-white p-2 rounded-2xl shadow-md w-full max-w-7xl">
          <table className="w-full text-left mb-4 border-collapse">
            <thead>
              <tr className="text-gray-500 border-b">
                <th className="p-2 text-center">Vehicle No</th>
                <th className="p-2 text-center">Name</th>
                <th className="p-2 text-center">Mobile</th>
                <th className="p-2 text-center ">Wallet Balance</th>
              </tr>
            </thead>
            <tbody>
              {users.filter((u) => u.userId).slice(0, 1).map((u) => (
                <React.Fragment key={u.userId}>
                  <tr
                    onClick={() =>
                      setExpandedRow(expandedRow === u.userId ? null : u.userId)
                    }
                    className="cursor-pointer p-4 hover:bg-gray-50"
                  >
                    <td className="p-2 text-center">{u.vehicleNo}</td>
                    <td className="p-2 text-center">{u.name}</td>
                    <td className="p-2 text-center">{u.mobile}</td>
                    <td className="p-2 text-center text-green-500 font-semibold">
                      ₹ {u.walletBalance}
                    </td>
                  </tr>

                {expandedRow === u.userId && (
                    <tr>
                      <td colSpan={5} className="p-6 px-10 bg-gray-50">
                        <div className="grid grid-cols-12 gap-6 items-end">
                          <div className="col-span-3">
                            <label className="block text-sm text-gray-500 mb-1">
                              Deduction Amount
                            </label>
                            <div className="relative">
                              <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                ₹
                              </span>
                              <input
                                type="number"
                                placeholder="100"
                                value={formValues[u.userId]?.amount || ""}
                                onChange={(e) =>
                                  handleInputChange(u.userId, "amount", e.target.value)
                                }
                                className="w-full pl-8 pr-3 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:outline-none"
                              />
                            </div>
                          </div>
                            
                          <div className="col-span-6">
                            <label className="block text-sm text-gray-500 mb-1">
                              Deduction Reason
                            </label>
                            <input
                              type="text"
                              placeholder="Enter remarks"
                              maxLength={80} 
                              value={formValues[u.userId]?.reason || ""}
                              onChange={(e) =>
                                handleInputChange(u.userId, "reason", e.target.value)
                              }
                              className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-black focus:outline-none"
                            />
                          </div>

                          <div className="col-span-6">
                             <label className="block text-sm text-gray-500 mb-1">
                               Deduction Type
                             </label>
                            <select
                                className="w-full border border-gray-300 rounded-lg p-2 text-sm"
                                value={formValues[u.userId]?.deductionType || ""}
                                onChange={(e) =>
                                  handleInputChange(u.userId, "deductionType", e.target.value)
                                }
                              >
                                <option value="" disabled>
                                  Select Deduction Type
                                </option>
                                {u?.deductionTypes?.map((type: { key: string; label: string },) => (
                                  <option key={type.key} value={type.key}>
                                    {type.label}
                                  </option>
                                ))}
                              </select>
                          </div>
                          
                          <div className="col-span-3 flex justify-end">
                            <button
                              onClick={() => handleDeduction(u.userId)}
                              className="px-6 py-2 bg-black text-white rounded-full hover:bg-gray-800 transition"
                            >
                              Deduct Amount
                            </button>
                          </div>
                        </div>
                      </td>
                    </tr>
                )}

                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {success && (
        <div className="fixed inset-0 bg-black/60 flex items-center justify-center">
          <div className="bg-white p-8 rounded-2xl shadow-lg text-center max-w-sm">
            <p className="text-lg font-medium mb-4">
              Amount Deducted Successfully
            </p>
            <button
              onClick={() => {setSuccess(false); handleSearch(search)}}
              className="px-6 py-2 bg-black text-white rounded-lg"
            >
              Continue to Dashboard
            </button>
          </div>
        </div>
      )}
    </div>
  );
}